import { flex } from "@/styles/mixins";
import styled from "styled-components";

export const LoginLayoutWrap = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  ${flex('row', 'flex-start', 'flex-start')};

  .layout--left,
  .layout--right {
    height: 100%;
    width: 50%;
  }

  .layout--left {
    > img {
      width: 100%;
      object-fit: inherit;
      height: 100%;
    }
  }

  .layout--right {
    padding: 0 24px;
    &--header {
      margin-bottom: 20px;
    }
  }

`